<template>
	<div class="login-page flex">
		<div class="box grow scrollable align-vertical side-box box-left">
			<div class="align-vertical-middle wrapper text-center">
				<img v-if="interfaceConfigurationActive" class="" :src="logo" style="max-width:340px;" alt="logo-left"/>
				<img v-else class="h-big image-logo" :src="logo" alt="logo-left"/>
				<h1 v-if="!interfaceConfigurationActive" class="h-big">Portaus</h1>
				<p class="p-50"><span v-html="slogan"></span></p>
			</div>
			<h1 v-if="interfaceConfigurationActive" style="position:absolute;color:#fff;bottom:0px;font-size:15px;margin-left:20px;">Propulsé par Portaus</h1>
		</div>
		<div class="box grow scrollable align-vertical side-box box-right">
			<div class="align-vertical-middle wrapper">

				<el-form class="form-box animated fadeInLeft" v-if="!invalidToken && !expiredToken && !resetPasswordDone" ref="ruleForm" :rules="rules" :model="form" @submit.prevent.native="resetPassword">
					<h2>Réinitialisation de votre mot de passe</h2>
					<p>Veuillez saisir votre nouveau mot de passe.</p>
					<el-form-item prop="password">
						<!-- <float-label class="styled"> -->
								<el-input type="password" v-bind:placeholder="$t('login.newPassword')" v-model="form.password" v-on:keyup.enter="resetPassword" ></el-input>
						<!-- </float-label> -->
					</el-form-item>
					<el-form-item prop="confirmation">
					<!-- <float-label class="styled"> -->
						<el-input type="password" v-bind:placeholder="$t('login.newPasswordConfirmation')" v-model="form.confirmation" v-on:keyup.enter="resetPassword" prop="confirmation"></el-input>
					<!-- </float-label> -->
					</el-form-item>
					<div class="flex text-center center pt-30 pb-10">
						<el-button plain size="small" @click="resetPassword" native-type="submit" class="login-btn pulse animated themed">
							{{ $t("login.resetPassword") }}
						</el-button>
					</div>

				</el-form>
				<div v-if="expiredToken" class="form-box" style="text-align:center;">
					<i class="el-icon-warning-outline" style="font-size:100px;"></i>
					<p>Le lien de modification de mot de passe est expiré.</p>
					<router-link to="/login" :underline="false"><i class="mdi mdi-arrow-left-bold-box-outline"><span slot="title">Retour</span></i></router-link>
				</div>
				<div v-if="invalidToken" class="form-box" style="text-align:center;">
					<i class="el-icon-warning-outline" style="font-size:100px;"></i>
					<p>Le lien de modification de mot de passe est invalide.</p>
					<router-link to="/login" :underline="false"><i class="mdi mdi-arrow-left-bold-box-outline"><span slot="title">Retour</span></i></router-link>
				</div>
				<div v-if="resetPasswordDone" class="form-box animated fadeInRight" style="text-align:center;">
					<h2>Confirmation</h2>
					<i class="el-icon-circle-check" style="font-size:100px;"></i>
					<p>Votre mot de passe a été sauvegardé avec succès!</p>
					<router-link to="/login" :underline="false"><i class="mdi mdi-arrow-left-bold-box-outline"><span slot="title">Se connecter</span></i></router-link>
				</div>
			</div>

		</div>

	</div>
</template>

<script>

import {AUTH_VALIDATE_TOKEN,AUTH_SET_TOKEN_VALID} from '../../../store/actions/auth'

export default {
	name: 'Login',
	data() {
		var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Veuillez saisir un nouveau mot de passe'));
        } else {
          if (this.form.confirmation !== '') {
            this.$refs.ruleForm.validateField('confirmation');
          }
          callback();
        }
      };
			var validatePass2 = (rule, value, callback) => {
	        if (value === '') {
	          callback(new Error('Veuillez saisir confirmer votre nouveau mot de passe'));
	        } else if (value !== this.form.password) {
	          callback(new Error('Les mots de passe ne concordent pas'));
	        } else {
	          callback();
	        }
	      };
		return {
			form : {
				password: '',
				confirmation: ''
			},
			invalidToken:false,
			expiredToken:false,
			resetPasswordDone : false,
			rules: {
          password: [
						{required : true,message: 'Veuillez saisir un nouveau mot de passe', trigger : 'blur'},
            { validator: validatePass, trigger: 'blur' }
          ],
          confirmation: [
						{required : true,message: 'Veuillez confirmer votre nouveau mot de passe', trigger : 'blur'},
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
		}
	},
	methods: {
		resetPassword(e){
			
			this.$refs['ruleForm'].validate((valid)=>{
				if(valid){
					this.$store.dispatch('AUTH_RESET_PASSWORD',{password:this.form.password, token : this.$route.query.token})
					.then(()=>{
						this.resetPasswordDone=true;
					})
				}else{
					// console.log("not valid");
					return false;
					
				}
			})
			e.preventDefault();
		}
	},
	computed : {
		interfaceConfigurationActive(){
			return (localStorage.INTERFACE_CONFIGURATION!=null && JSON.parse(localStorage.INTERFACE_CONFIGURATION).active);
		},
		slogan(){
			if(this.interfaceConfigurationActive){
				return JSON.parse(localStorage.INTERFACE_CONFIGURATION).slogan;
			}else{
				return `"Le mot <strong>portaus</strong> est un dérivé du mot porte. Le sens ancien était « grand panneau de bois servant de porte », puis dès le xviie siècle, on note les sens actuels restreints aux édifices religieux de « façade d'une église où est la porte principale » et « grande porte d'une église ou d'un temple ». De manière contemporaine, il est employé pour désigner <strong>toute porte plus monumentale qu'une porte ordinaire</strong>."`;
			}
		},
		logo(){
			if(this.interfaceConfigurationActive){
				return require('@/assets/images/'+JSON.parse(localStorage.INTERFACE_CONFIGURATION).logo);
			}else{
				return require("@/assets/images/logo.svg");
			}
		}
	},
	mounted(){
		//validation du token par l'API.
		//Si le token est bon alors on demande a l'utilisateur de changer son mot de passe
		//Sinon, on affiche un message d'erreur avec un lien vers la page de login
		this.$store.dispatch('AUTH_SET_TOKEN_VALID', false);
		this.$store.dispatch('AUTH_VALIDATE_TOKEN', this.$route.query.token)
			.then(err=>{
				if(err){
					if(err.response.data.jse_info.errorCode==="EXPIRED_TOKEN"){
						this.expiredToken=true;
					}else{
						this.invalidToken=true;
					}
				}
			})
	}
}
</script>

<style lang="scss">
@import '../../../assets/scss/_variables';

.login-page {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 0 !important;

	.side-box {
		.wrapper {
			width: 100%;
			box-sizing: border-box;
			padding: 20px;
		}
	}

	.box-left {
		background-image: url('../../../assets/images/login_cover.jpg');
		background-size: cover;
		background-position: 50% 50%;

		.wrapper {
			.image-logo {
				width: 90%;
				max-width: 100px;
				margin-top: 20px;
			}

		}
	}
	.box-right {
		background: white;
		color: var(--background-color);
	}

	.form-box {
		width: 100%;
		max-width: 400px;
		padding: 30px;
		box-sizing: border-box;
		margin: 20px auto;
		//background: transparent;

		a {
			font-size: 14px;
			color: var(--color-accent);
			text-decoration: none;
			font-weight: 500;
		}

		.image-logo {
			width: 80px;
			margin: 0px auto;
			margin-bottom: 70px;
			display: block;
		}

		.login-btn {
			background: rgba(var(--color-accent-rgb), .2);
			color: var( --text-color);
			border-color: var(--text-color);
			border-width: 2px;
			font-weight: bold;
			border-radius: 0;

			&:hover {
				background: rgba(var(--color-accent-rgb), 1);
				border-color: var(--text-color);
				color: var( --text-color);
			}
		}
	}
}

@media (max-width: 1200px) {
.login-page {
	.box-left {
		.wrapper {
			.h-big {
				font-size: 50px;
			}
		}
	}
}
}
@media (max-width: 900px) {
.login-page {
	.box-left {
		.wrapper {
			.h-big {
				font-size: 30px;
			}
		}
	}
}
}
@media (max-width: 768px) {
.login-page {
	display: block;
	overflow: auto;

	.side-box {
		display: block;
	}
}
}
</style>
